import { useNavigate } from "react-router-dom";
import { ODIN_START_PAGE_SWITCH_KEY } from "../../../common/constants";
import { Routes } from "../../../routes";

export const useRouteToFlowStartPage = () => {
  const history = useNavigate();
  const isStartPageSwitchedOn = localStorage.getItem(ODIN_START_PAGE_SWITCH_KEY) === "true";
  const pathToRoute = `${Routes.freya}${isStartPageSwitchedOn ? Routes.start : Routes.scanQrCode}`;

  const routeToFlowStartPage = () => {
    history(pathToRoute);
  };

  return { routeToFlowStartPage };
};
